export type ApiKeyValidationStatus = 'valid' | 'invalid' | 'rate_limited' | 'unavailable';

export async function validateApiKey(backendUrl: string, apiKey: string): Promise<ApiKeyValidationStatus> {
  const response = await fetch(`${backendUrl}/auth/validate-api-key`, {
    method: 'POST',
    headers: {'x-api-key': apiKey},
  });

  if (response.status === 429) return 'rate_limited';
  if (!response.ok) return 'unavailable';

  const data: {valid?: boolean} = await response.json();
  return data.valid === true ? 'valid' : 'invalid';
}
